import Config from './config'
var api = Config.api

const verticalAPIRoot = api.BASE_URL + '/verticals'
const signInPassAPIRoot = api.BASE_URL + '/sign-in-pass'

class VerticalService {

  getCurrentVertical() {
    return api.getCall(verticalAPIRoot + '/current', api.DoNothing, api.DoNothing)
  }

  // Each vertical's address in this environment, for signing out everywhere (#32).
  getVerticalHosts() {
    return api.getCall(verticalAPIRoot + '/hosts', api.DoNothing, api.DoNothing)
  }

  // One-time pass that opens another vertical's address without signing in again (#27).
  createSignInPass(VerticalCode) {
    return api.postCall(signInPassAPIRoot + '/' + VerticalCode, api.NoPaylaod, api.DoNothing, api.DoNothing)
  }

  // A one-time pass that signs the user in to the Directory SuperAdmin for the current vertical (#28).
  createDirectoryPass() {
    return api.postCall(signInPassAPIRoot + '/directory', api.NoPaylaod, api.DoNothing, api.DoNothing)
  }

  redeemSignInPass(Pass) {
    return api.postCall(signInPassAPIRoot + '/redeem', { Pass }, api.DoNothing, api.DoNothing)
  }

  getVerticalSummaries() {
    return api.getCall(verticalAPIRoot + '/summary', api.DoNothing, api.ShowAlert)
  }

  // All-verticals report (#41): from and to are yyyy-MM-dd, both included.
  getVerticalReport(from, to) {
    const query = '?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to)
    return api.getCall(verticalAPIRoot + '/report' + query, api.DoNothing, api.ShowAlert)
  }

  getVerticals() {
    return api.getCall(verticalAPIRoot, api.DoNothing, api.ShowAlert)
  }

  getVertical(VerticalCode) {
    return api.getCall(verticalAPIRoot + '/' + VerticalCode, api.DoNothing, api.ShowAlert)
  }

  // #33: save one vertical's editable settings (basic info, email sender, links). Logo URLs and
  // Draft/Live status are saved by their own calls, not here.
  saveVerticalSettings(VerticalCode, settings) {
    return api.putCall(verticalAPIRoot + '/' + VerticalCode, settings, api.DoNothing, api.DoNothing)
  }

  // #33: one vertical's settings change history, newest first.
  getSettingsHistory(VerticalCode) {
    return api.getCall(verticalAPIRoot + '/' + VerticalCode + '/settings-history', api.DoNothing, api.ShowAlert)
  }

  // #33: upload one of a vertical's images. kind: 'logo' | 'logo-white' | 'favicon'. The file is sent
  // as multipart/form-data; the response carries the saved image's URL.
  uploadVerticalLogo(VerticalCode, kind, file) {
    const form = new FormData()
    form.append('file', file)
    return api.uploadCall(verticalAPIRoot + '/' + VerticalCode + '/logo/' + kind, form, api.DoNothing, api.DoNothing)
  }

  // #33: remove one of a vertical's images (sets its URL to null). kind: 'logo' | 'logo-white' | 'favicon'.
  removeVerticalLogo(VerticalCode, kind) {
    return api.deleteCall(verticalAPIRoot + '/' + VerticalCode + '/logo/' + kind, api.DoNothing, api.DoNothing)
  }

  // Send a test email using this vertical's email sender config.
  sendTestEmail(VerticalCode, to) {
    return api.postCall(verticalAPIRoot + '/' + VerticalCode + '/send-test-email', { To: to }, api.DoNothing, api.DoNothing)
  }

  // #33: a vertical's go-live readiness — status and each config check, with whether it can go live.
  getGoLiveChecks(VerticalCode) {
    return api.getCall(verticalAPIRoot + '/' + VerticalCode + '/go-live-checks', api.DoNothing, api.DoNothing)
  }

  // #33: switch a vertical to Live. Succeeds only when every check passes.
  goLive(VerticalCode) {
    return api.postCall(verticalAPIRoot + '/' + VerticalCode + '/go-live', api.NoPaylaod, api.DoNothing, api.DoNothing)
  }

  // Add (upsert) one web address for a vertical.
  addVerticalHost(VerticalCode, host, isPrimary, isCentralSignIn) {
    return api.postCall(verticalAPIRoot + '/' + VerticalCode + '/hosts', { Host: host, IsPrimary: isPrimary, IsCentralSignIn: isCentralSignIn }, api.DoNothing, api.DoNothing)
  }

  // Remove one web address from a vertical.
  removeVerticalHost(VerticalCode, host) {
    return api.deleteCall(verticalAPIRoot + '/' + VerticalCode + '/hosts/' + encodeURIComponent(host), api.DoNothing, api.DoNothing)
  }
}
export default new VerticalService()
